export const EXPORT_FIELDS = [
  { id: "id", label: "ID do usuário", defaultChecked: false },
  { id: "username", label: "Nome de usuário", defaultChecked: true },
  { id: "nickname", label: "Apelido", defaultChecked: true },
  { id: "role", label: "Permissão", defaultChecked: true },
  { id: "email", label: "Email", defaultChecked: true },
  { id: "phone", label: "Telefone", defaultChecked: true },
  { id: "cpf", label: "CPF", defaultChecked: true },
  { id: "plans", label: "Planos / Assinaturas", defaultChecked: true },
  { id: "created_at", label: "Data de inscrição", defaultChecked: true },
];

export const DEFAULT_EXPORT_FIELDS = EXPORT_FIELDS
  .filter((f) => f.defaultChecked)
  .map((f) => f.id);
